/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateRunRequest } from '../models/CreateRunRequest';
import type { CreateStrategyRequest } from '../models/CreateStrategyRequest';
import type { CreateValidationRequest } from '../models/CreateValidationRequest';
import type { CreateVersionRequest } from '../models/CreateVersionRequest';
import type { DeclareHoldoutRequest } from '../models/DeclareHoldoutRequest';
import type { HoldoutListResponse } from '../models/HoldoutListResponse';
import type { HoldoutResponse } from '../models/HoldoutResponse';
import type { RetireStrategyRequest } from '../models/RetireStrategyRequest';
import type { RunListResponse } from '../models/RunListResponse';
import type { RunResponse } from '../models/RunResponse';
import type { StrategyListResponse } from '../models/StrategyListResponse';
import type { StrategyResponse } from '../models/StrategyResponse';
import type { StrategyState } from '../models/StrategyState';
import type { SweepResponse } from '../models/SweepResponse';
import type { TradeListResponse } from '../models/TradeListResponse';
import type { UpdateStrategyRequest } from '../models/UpdateStrategyRequest';
import type { ValidationListResponse } from '../models/ValidationListResponse';
import type { ValidationResponse } from '../models/ValidationResponse';
import type { VersionListResponse } from '../models/VersionListResponse';
import type { VersionResponse } from '../models/VersionResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ResearchService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List Runs
     * @returns RunListResponse Successful Response
     * @throws ApiError
     */
    public listRuns({
        strategyId,
        kind,
    }: {
        strategyId?: (number | null),
        kind?: (string | null),
    }): CancelablePromise<RunListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/backtests',
            query: {
                'strategy_id': strategyId,
                'kind': kind,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Run
     * Record a run request. **202, not 201** — see the module docstring.
     *
     * Accepted-for-processing is the honest code for a row that has been written and not started,
     * and it stays honest when a worker exists. A 201 would say the thing the client asked for now
     * exists, and what exists is a request for it.
     * @returns RunResponse Successful Response
     * @throws ApiError
     */
    public createRun({
        requestBody,
    }: {
        requestBody: CreateRunRequest,
    }): CancelablePromise<RunResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/backtests',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Run
     * @returns RunResponse Successful Response
     * @throws ApiError
     */
    public getRun({
        runId,
    }: {
        runId: number,
    }): CancelablePromise<RunResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/backtests/{run_id}',
            path: {
                'run_id': runId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Benchmark Curve
     * The passive control's curve, in the same format and for the same reasons as the run's own.
     *
     * 404 when the run predates migration `0048`, which is most of them. **Not an empty array** — a
     * client given `[]` would draw a flat control at zero, which is a specific and wrong claim about
     * the market rather than the absence of one.
     * @returns any Successful Response
     * @throws ApiError
     */
    public getBenchmarkCurve({
        runId,
    }: {
        runId: number,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/backtests/{run_id}/benchmark-curve',
            path: {
                'run_id': runId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Cancel Run
     * @returns RunResponse Successful Response
     * @throws ApiError
     */
    public cancelRun({
        runId,
    }: {
        runId: number,
    }): CancelablePromise<RunResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/backtests/{run_id}/cancel',
            path: {
                'run_id': runId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Equity Curve
     * The stored curve: **gzipped JSON, served as gzipped JSON**.
     *
     * The column is `bytea` holding a compressed series, and the format is the writer's —
     * `jmt_research.store.encode_curve`. Decoding it here to re-encode it would put one format
     * decision in two places.
     *
     * So the bytes go out unchanged, with `Content-Encoding: gzip` and `Content-Type:
     * application/json`. **The browser decompresses it before the client sees it**, so a `fetch`
     * gets JSON and the frontend gains no dependency — which is why the stored format is gzipped
     * JSON rather than something smaller and bespoke: a bespoke layout would need a decoder in
     * TypeScript, and two implementations of a format with no test that they agree.
     *
     * `Content-Length` is deliberately not set: it would be the compressed length, and a client that
     * trusted it after decoding would truncate. Starlette omits it for a raw `Response` with an
     * explicit encoding header.
     * @returns any Successful Response
     * @throws ApiError
     */
    public getEquityCurve({
        runId,
    }: {
        runId: number,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/backtests/{run_id}/equity-curve',
            path: {
                'run_id': runId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Trades
     * @returns TradeListResponse Successful Response
     * @throws ApiError
     */
    public listTrades({
        runId,
    }: {
        runId: number,
    }): CancelablePromise<TradeListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/backtests/{run_id}/trades',
            path: {
                'run_id': runId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Holdouts
     * @returns HoldoutListResponse Successful Response
     * @throws ApiError
     */
    public listHoldouts(): CancelablePromise<HoldoutListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/holdouts',
        });
    }
    /**
     * Declare Holdout
     * Lock a holdout period for a strategy version. **Once, and it cannot be moved.**
     *
     * *"Configure a holdout period that the platform locks — the operator cannot see holdout results
     * until everything else has passed"* (`User-Journeys.md`). Declaring it is step 2 of the
     * workflow, not step 8: a holdout chosen after the work is a holdout chosen with knowledge of
     * the result.
     * @returns HoldoutResponse Successful Response
     * @throws ApiError
     */
    public declareHoldout({
        requestBody,
    }: {
        requestBody: DeclareHoldoutRequest,
    }): CancelablePromise<HoldoutResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/holdouts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Holdout
     * @returns HoldoutResponse Successful Response
     * @throws ApiError
     */
    public getHoldout({
        strategyVersionId,
    }: {
        strategyVersionId: number,
    }): CancelablePromise<HoldoutResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/holdouts/{strategy_version_id}',
            path: {
                'strategy_version_id': strategyVersionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Strategies
     * @returns StrategyListResponse Successful Response
     * @throws ApiError
     */
    public listStrategies({
        state,
        tag,
        includeRetired = false,
    }: {
        state?: (StrategyState | null),
        tag?: (string | null),
        includeRetired?: boolean,
    }): CancelablePromise<StrategyListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/strategies',
            query: {
                'state': state,
                'tag': tag,
                'include_retired': includeRetired,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Strategy
     * @returns StrategyResponse Successful Response
     * @throws ApiError
     */
    public createStrategy({
        requestBody,
    }: {
        requestBody: CreateStrategyRequest,
    }): CancelablePromise<StrategyResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/strategies',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Retire Strategy
     * *"Retire, with reason; never hard-deletes."*
     *
     * A `DELETE` that returns the resource looks odd and is correct here: nothing was deleted, and
     * the client needs the new state. The reason is required by the body **and** by a check
     * constraint, so a retirement with no reason cannot be written even from psql.
     * @returns StrategyResponse Successful Response
     * @throws ApiError
     */
    public retireStrategy({
        strategyId,
        requestBody,
    }: {
        strategyId: number,
        requestBody: RetireStrategyRequest,
    }): CancelablePromise<StrategyResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/strategies/{strategy_id}',
            path: {
                'strategy_id': strategyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Strategy
     * @returns StrategyResponse Successful Response
     * @throws ApiError
     */
    public getStrategy({
        strategyId,
    }: {
        strategyId: number,
    }): CancelablePromise<StrategyResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/strategies/{strategy_id}',
            path: {
                'strategy_id': strategyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Strategy
     * @returns StrategyResponse Successful Response
     * @throws ApiError
     */
    public updateStrategy({
        strategyId,
        requestBody,
    }: {
        strategyId: number,
        requestBody: UpdateStrategyRequest,
    }): CancelablePromise<StrategyResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/strategies/{strategy_id}',
            path: {
                'strategy_id': strategyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Versions
     * @returns VersionListResponse Successful Response
     * @throws ApiError
     */
    public listVersions({
        strategyId,
    }: {
        strategyId: number,
    }): CancelablePromise<VersionListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/strategies/{strategy_id}/versions',
            path: {
                'strategy_id': strategyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Version
     * A hand-written version. **The version number is derived, never supplied.**
     *
     * `API-Spec.md` writes the body as `{code, parameters}` and no version field, which is the right
     * shape: a client that chose its own numbers would eventually choose one twice, and the unique
     * `(strategy_id, version)` would turn that into an error the operator cannot act on.
     *
     * The hash is computed here rather than accepted from the client. A supplied hash is a claim
     * about the code, and the whole value of `code_hash` is that it is a *fact* about it.
     * @returns VersionResponse Successful Response
     * @throws ApiError
     */
    public createVersion({
        strategyId,
        requestBody,
    }: {
        strategyId: number,
        requestBody: CreateVersionRequest,
    }): CancelablePromise<VersionResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/strategies/{strategy_id}/versions',
            path: {
                'strategy_id': strategyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Version
     * @returns VersionResponse Successful Response
     * @throws ApiError
     */
    public getVersion({
        strategyId,
        version,
    }: {
        strategyId: number,
        version: number,
    }): CancelablePromise<VersionResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/strategies/{strategy_id}/versions/{version}',
            path: {
                'strategy_id': strategyId,
                'version': version,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Sweep
     * A sweep's configurations, and the summary computed when it finished.
     *
     * 🔴 **`configurations_tried` is returned at the top level and is never optional.** *"The best of
     * 500 is a fundamentally different claim from this works, and the UI must not let me confuse
     * them."* It is the size of the grid; `configurations_executed` is how many actually ran, and the
     * two differ exactly when a sweep was cancelled.
     * @returns SweepResponse Successful Response
     * @throws ApiError
     */
    public getSweep({
        runId,
    }: {
        runId: number,
    }): CancelablePromise<SweepResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/sweeps/{run_id}',
            path: {
                'run_id': runId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Validations
     * @returns ValidationListResponse Successful Response
     * @throws ApiError
     */
    public listValidations({
        strategyVersionId,
    }: {
        strategyVersionId?: (number | null),
    }): CancelablePromise<ValidationListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/validations',
            query: {
                'strategy_version_id': strategyVersionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Validation
     * Run the promotion gate against a version's stored evidence, and record the verdict.
     *
     * **Synchronous, unlike a backtest**, because it computes nothing: it reads the metrics four
     * completed runs already wrote. A gate that needed a worker would be a gate whose verdict lags
     * the evidence it is about.
     *
     * 🔴 **Evidence that is absent produces `unknown`, and `unknown` is not a pass.** A version with
     * no walk-forward run does not fail G3 for being bad — it fails for being unevaluated, and the
     * reason says which. That distinction is the whole reason every criterion returns a row.
     *
     * 🔴 **And every piece of it comes from one rung.** See `_evidence`.
     * @returns ValidationResponse Successful Response
     * @throws ApiError
     */
    public createValidation({
        requestBody,
    }: {
        requestBody: CreateValidationRequest,
    }): CancelablePromise<ValidationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/validations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Validation
     * @returns ValidationResponse Successful Response
     * @throws ApiError
     */
    public getValidation({
        validationId,
    }: {
        validationId: number,
    }): CancelablePromise<ValidationResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/validations/{validation_id}',
            path: {
                'validation_id': validationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unlock Holdout
     * Open the holdout. *"Only if all else passed"* — and once.
     *
     * 409 `research.holdout_locked` when G1-G11 have not all passed, which is `API-Spec.md`'s own
     * rule and the same code the overlap refusal uses, because they are one rule seen from two
     * sides.
     *
     * ⚠ **The verdict this reads is the one stored on the validation, not one recomputed now.** A
     * fresh evaluation could pass on evidence that arrived after the verdict was recorded, and the
     * lock would then open against a row that says it should not. Post a new validation instead —
     * they are append-only precisely so that is cheap.
     * @returns HoldoutResponse Successful Response
     * @throws ApiError
     */
    public unlockHoldout({
        validationId,
    }: {
        validationId: number,
    }): CancelablePromise<HoldoutResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/validations/{validation_id}/unlock-holdout',
            path: {
                'validation_id': validationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
